import { Mapper } from 'src/base/mapper'
import { ProductItemTypeEntity } from 'src/data/entities/product.entity'
import { ProductItemTypeModel } from 'src/domain/models/product.model'

export class ProductItemMapper extends Mapper<ProductItemTypeEntity, ProductItemTypeModel> {
	mapFrom(param: ProductItemTypeEntity): ProductItemTypeModel {
		return {
			itemCode: param.itemCode,
			itemDescription: param.itemDescription,
		}
	}

	mapTo(param: ProductItemTypeModel): ProductItemTypeEntity {
		return {
			productId: null,
			itemCode: param.itemCode,
			itemDescription: param.itemDescription,
			isActive: null,
			dateCreated: null,
			dateUpdated: null,
			product: null,
		}
	}
}
